<template>
  <div v-if="dialogVisible" class="cv-grade-cover" style="z-index:1050">
    <div class="cv-grade">
      <div v-if="grade.等级" class="cv-level-box">
        <img :src="imageMap[grade.等级]" />
        <!-- <img v-if="grade.等级==='A+'" src="../../../assets/images/A+.png"> -->
        <!-- <img :src="`../../../assets/images/${grade.等级}.png`"> -->
      </div>
      <div class="cv-grade-header mb10">
        <div class="cv-header-left"><span>简历打分</span></div>
        <div class="cv-header-right">
          <span>{{ cv.data && cv.data.姓名 }}</span> <span>{{ grade.简历等级 }}</span>
        </div>
      </div>
      <div class="cv-grade-content mb10">
        <div class="cv-grade-content-type mb10">
          <p class="cv-grade-title mb10">一、教育经历</p>
          <div v-for="(item, index) in edu" :key="item.label" class="cv-grade-detail mb10">
            <span class="detail-label">{{ index + 1 }}、{{ item.label }}</span>
            <div class="detail-options">
              <span v-for="tag in item.options" :key="tag" :class="{ 'option-check': tag === grade[item.label] }">{{
                tag
              }}</span>
            </div>
          </div>
        </div>
        <div class="cv-grade-content-type mb10">
          <p class="cv-grade-title mb10">二、工作经历</p>
          <div v-for="(item, index) in work" :key="item.label" class="cv-grade-detail mb10">
            <span class="detail-label">{{ index + 1 }}、{{ item.label }}</span>
            <div class="detail-options">
              <span v-for="tag in item.options" :key="tag" :class="{ 'option-check': tag === grade[item.label] }">{{
                tag
              }}</span>
            </div>
          </div>
        </div>
        <div class="cv-grade-content-type mb10">
          <p class="cv-grade-title mb10">三、评价</p>
          <div class="cv-grade-detail" style="flex-direction: column;">
            <p v-for="item in grade.评价" :key="item" class=" mb10" style="color:#999">{{ item }}</p>
          </div>
          <div class="cv-grade-result">
            <span class="grade-num">评分：{{ grade.评分 }}分</span>
            <el-button type="text" style="padding:4px 0" @click="addFeedback">评分不准，我要反馈</el-button>
          </div>
        </div>
        <div v-if="grade.人选画像预测" class="cv-grade-content-type mb10">
          <p class="cv-grade-title mb10">简历亮点分析</p>
          <div
            v-if="grade.人选画像预测.occupation && grade.人选画像预测.occupation.length > 0"
            class="cv-grade-detail mb10"
          >
            <span class="detail-label">工作经历亮点</span>
            <div class="detail-options">
              <el-tag
                v-for="tag in grade.人选画像预测.occupation"
                :key="tag"
                type="success"
                class="margin-md word-break-class"
                >{{ tag }}</el-tag
              >
            </div>
          </div>
          <div
            v-if="grade.人选画像预测.education && grade.人选画像预测.education.length > 0"
            class="cv-grade-detail mb10"
          >
            <span class="detail-label">学习经历亮点</span>
            <div class="detail-options">
              <el-tag
                v-for="tag in grade.人选画像预测.education"
                :key="tag"
                type="info"
                class="margin-md word-break-class"
                >{{ tag }}</el-tag
              >
            </div>
          </div>
          <div v-if="grade.人选画像预测.project && grade.人选画像预测.project.length > 0" class="cv-grade-detail mb10">
            <span class="detail-label">项目经历亮点</span>
            <div class="detail-options">
              <el-tag
                v-for="tag in grade.人选画像预测.project"
                :key="tag"
                type="warning"
                class="margin-md word-break-class"
                >{{ tag }}</el-tag
              >
            </div>
          </div>
          <div v-if="grade.人选画像预测.others && grade.人选画像预测.others.length > 0" class="cv-grade-detail mb10">
            <span class="detail-label">其他亮点</span>
            <div class="detail-options">
              <el-tag
                v-for="tag in grade.人选画像预测.others"
                :key="tag"
                type="danger"
                class="margin-md word-break-class"
                >{{ tag }}</el-tag
              >
            </div>
          </div>
          <div v-if="grade.人选画像预测.tags && grade.人选画像预测.tags.length > 0" class="cv-grade-detail mb10">
            <span class="detail-label">亮点标签</span>
            <div class="detail-options">
              <el-tag v-for="tag in grade.人选画像预测.tags" :key="tag" class="margin-md word-break-class">{{
                tag
              }}</el-tag>
            </div>
          </div>
        </div>
      </div>
      <div class="cv-grade-footer mb10">
        <div v-if="maybeCategories.length !== 0" class="cv-choose-category">
          <div class="checkbox-box">
            <span class="checkbox-label">我们预测人选可能：</span>
            <el-checkbox-group v-model="categories" @change="changeCategory">
              <el-checkbox v-for="cate in maybeCategories" :key="cate" :label="cate"></el-checkbox>
              <el-checkbox label="以上都不是"></el-checkbox>
            </el-checkbox-group>
          </div>
          <p class="category-alert">
            请勾选您认为对的职能模块，会自动标注；如果没有选择以上都不是，小阿会根据您的反馈调整算法的
          </p>
        </div>
        <div class="btn-box"><el-button type="primary" size="mini" @click="confirm">确定</el-button></div>
      </div>

      <!-- component -->
      <CvGradeFeedback ref="CvGradeFeedback"></CvGradeFeedback>
    </div>
  </div>
</template>
<script>
import Aplus from '../../../assets/images/A+.png'
import A from '../../../assets/images/A.png'
import B from '../../../assets/images/B.png'
import C from '../../../assets/images/C.png'

import CvGradeFeedback from './CvGradeFeedback'

const testRes = {
  status: 'success',
  msg: '成功',
  data: {
    简历评分: {
      教育经历: {
        毕业院校: {
          标准分: 100,
          实际分: 22,
          评价: {
            评语: '学历背景好',
            学历等级: [
              {
                学历: '硕士',
                学历等级: '清北复交',
              },
              {
                学历: '本科',
                学历等级: '清北复交',
              },
            ],
            最高学历: '硕士',
          },
        },
        学位: {
          标准分: 90,
          实际分: 9,
        },
      },
      工作经历: {
        公司平台: {
          标准分: 100,
          实际分: 15,
        },
        最近工作经历: {
          标准分: 100,
          实际分: 5,
        },
        稳定性: {
          标准分: 100,
          实际分: 15,
        },
        工作经验: {
          标准分: 100,
          实际分: 14,
        },
        评价: {
          平台: '目前就职于头部平台，工作经历50%以上在头部平台',
          稳定性: '工作很稳定',
        },
      },
      能力: {
        性别: {
          标准分: 100,
          实际分: 15,
        },
        证书: {
          标准分: 0,
          实际分: 0,
        },
      },
      评价: {
        // 可能为空
        年龄: '年龄偏大',
      },
      总评分: 95,
    },
  },
}
// 等级对应
const gradeMap = {
  'A+': '精品简历',
  A: '优质简历',
  B: '良好',
  C: '一般',
}
// 背景对应
const backgroundMap = {
  'A+': '人选背景优秀',
  B: '人选背景一般',
}
// 稳定性(标准分)
const stabilityMap = {
  '100': '很稳定',
  '80': '较稳定',
  '60': '一般',
  '-30': '不稳定',
  '-40': '转换频繁',
}
// 工作经验(标准分)
const experienceMap = {
  '100': '8年以上',
  '80': '5-8年',
  '60': '3-5年',
  '40': '3年以下',
  '20': '无经验',
}
// 当前公司(标准分)
const currentCompanyMap = {
  '100': '头部平台',
  '60': '中型平台',
  '20': '小型平台',
}

export default {
  components: { CvGradeFeedback },
  data() {
    return {
      dialogVisible: false,
      cvDetail: {},
      grade: {},
      edu: [
        { label: '最高学历', options: ['本科', '硕士', '博士', '专科', '其他'] },
        { label: '本科院校', options: ['清北复交', '常青藤', '985', '211', '一本', '二三本', '中金line', '中信line',] },
        { label: '硕士院校', options: ['清北复交', '常青藤', '985', '211', '一本', '二三本', '中金line', '中信line',] },
      ],
      work: [
        { label: '稳定性', options: ['很稳定', '较稳定', '一般', '不稳定', '转换频繁'] },
        { label: '工作经验', options: ['8年以上', '5-8年', '3-5年', '3年以下', '无经验'] },
        { label: '当前公司', options: ['头部平台', '中型平台', '小型平台'] },
      ],
      imageMap: {
        'A+': Aplus,
        A,
        B,
        C,
      },
      categories: [],
      maybeCategories: [],
    }
  },
  methods: {
    async open(cv) {
      this.cv = cv
      this.categories = []
      this.dialogVisible = true
      this.getCvGrade(cv)
      this.getCategories()
    },
    addFeedback() {
      this.$refs.CvGradeFeedback.open(this.grade, this.cv)
    },
    async getCategories() {
      const categories = (this.cv.标签预测 && this.cv.标签预测.建议职能模块) || []
      if (categories.length !== 0) {
        this.maybeCategories = categories
      } else this.maybeCategories = []
    },
    async confirm() {
      if (this.categories.length === 0) {
        this.dialogVisible = false
      } else {
        if (this.loading) return this.$message.error('保存中，请稍等')
        this.loading = true

        if (this.categories[0] === '以上都不是') {
          this.dialogVisible = false
          this.addCvGradeFeedback()
        } else {
          const res = await app
            .service('company')
            .radishAddCategoryByMd5({ md5: this.cv.md5, categories: this.categories })
          if (res.status === 'success') {
            this.$message.success('已为人选补全只能模块')
            this.dialogVisible = false
          } else this.$message.error(res.msg)
        }
        this.loading = false
      }
    },
    //  async dopost_unsafe(command) {
    //   const isPredict = true

    //   let jsonObject = JSON.parse(JSON.stringify(this.documentData))
    //   if (this.keywords) {
    //     //补充新的关键词
    //     const arr = jsonObject.data.项目经历 || []
    //     arr.push({
    //       项目描述: this.keywords,
    //     })
    //     jsonObject.data.项目经历 = arr
    //   }

    //   //4.执行
    //   const form = {
    //     label: this.label,
    //     topn: this.topn,
    //     topk: this.topk,
    //     jsonObject: jsonObject,
    //     command: command,
    //   }
    //   let re
    //   try {
    //     re = await window.app.service('misc').predictOrInterprete(form)
    //   } catch (e) {
    //     throw new Error(command + '执行失败:' + e)
    //   }
    //   if (re.status !== 'success') {
    //     throw new Error('执行失败:' + JSON.stringify(re))
    //   }

    //   //predict接口,虽然status为success,但仍有可能附带error_message,如: "错误:简历没有解析内容。"
    //   if (re.data.error_message) {
    //     throw new Error('错误:' + re.data.error_message)
    //   }

    //   if (isPredict) {
    //     this.predictResult = re.data
    //   } else {
    //     this.interpretResult = re.data[0]
    //   }

    //   if (isPredict) {
    //     console.log('predictResult', this.predictResult)
    //   } else {
    //     console.log('interpretResult', this.interpretResult)
    //   }

    //   this.$forceUpdate()
    // },
    changeCategory() {
      if (this.categories.includes('以上都不是')) this.categories = ['以上都不是']
    },
    async getCvGrade(cv) {
      const res = await app.service('resumeEval').evaluateNew({ _id: cv.md5 || cv._id })
      // const res = testRes
      if (res.status === 'success') {
        this.cvDetail = res.data && res.data.简历评分
        this.init()
      } else {
        this.$message.error(res.msg)
        this.dialogVisible = false
      }
    },
    init() {
      this.grade = {}
      const { cvDetail } = this
      const level = this.getGradeLevel(cvDetail.总评分)
      const grade = { 评价: [] }
      const eduDetail = (cvDetail.教育经历 && cvDetail.教育经历.毕业院校) || {}
      const workDetail = cvDetail.工作经历 || {}
      grade.最高学历 = (eduDetail.评价 && eduDetail.评价.最高学历) || ''
      grade.本科院校 =
        ((eduDetail.评价 && eduDetail.评价.学历等级) || []).filter(v => v.学历 === '本科').map(v => v.学历等级)[0] || ''
      grade.硕士院校 =
        ((eduDetail.评价 && eduDetail.评价.学历等级) || []).filter(v => v.学历 === '硕士').map(v => v.学历等级)[0] || ''

      grade.稳定性 = stabilityMap[workDetail.稳定性 && workDetail.稳定性.标准分] || ''
      grade.工作经验 = experienceMap[workDetail.工作经验 && workDetail.工作经验.标准分] || ''
      grade.当前公司 = currentCompanyMap[workDetail.最近工作经历 && workDetail.最近工作经历.标准分] || ''

      grade.等级 = level
      grade.评分 = cvDetail.总评分
      grade.简历等级 = gradeMap[level]

      grade.评价.push(`${grade.简历等级}${backgroundMap[level] ? `，${backgroundMap[level]}` : ''}`)
      grade.评价.push(
        `${
          eduDetail.评价 && eduDetail.评价.评语 ? `${eduDetail.评价 && eduDetail.评价.评语}，` : ''
        }${workDetail.评价 && workDetail.评价.稳定性}`,
      )
      grade.评价.push(`${(workDetail.评价 && workDetail.评价.平台) || ''}`)
      if (cvDetail.评价 && cvDetail.评价.年龄)
        grade.评价.push(
          `（${cvDetail.评价 && cvDetail.评价.年龄}，超过40岁，如果不是高管层级，则不是优质简历，请注意）`,
        )

      grade.评价 = grade.评价.filter(v => v && v !== 'undefined')
      grade.url = `../../../assets/images/${level}.png`
      if (cvDetail.人选画像预测 && cvDetail.人选画像预测.highlights) {
        grade.人选画像预测 = cvDetail.人选画像预测.highlights
      }
      this.grade = grade
    },
    getGradeLevel(num = 0) {
      if (num > 79) return 'A+'
      else if (num > 58) return 'A'
      else if (num > 37) return 'B'
      else return 'C'
    },
    async addCvGradeFeedback() {
      const feedback = {
        反馈详情: '职能模卡预测不准确',
      }

      await app.service('company').addCvGradeFeedback({ md5: this.cv.md5, feedback: feedback })
    },
  },
}
</script>
<style scoped>
.cv-grade-cover {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  overflow: auto;
  display: flex;
  justify-content: center;
  padding-top: 150px;
  padding-bottom: 100px;
}
.cv-grade {
  width: 700px;
  background-color: #fff;
  border-radius: 4px;
  -webkit-box-shadow: 0 0 5px 0 #d0d0d0;
  box-shadow: 0 0 5px 0 #d0d0d0;
  padding: 20px 30px;
  align-self: baseline;
  position: relative;
}
.cv-grade-header {
  border-bottom: 1px solid #000;
  display: flex;
  padding-bottom: 10px;
}
.cv-grade-content {
  border-bottom: 1px solid #000;
  padding-bottom: 10px;
}
.cv-header-left {
  margin-right: 10px;
  flex: none;
  font-size: 24px;
  padding: 10px 20px;
  border: 2px solid #000;
  border-radius: 4px;
}
.cv-header-right {
  flex: auto;
  font-size: 24px;
  padding: 9px 20px;
  border: 2px solid #c1c1c1;
  color: #cbcbcb;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cv-header-right .name {
  font-size: 20px;
  color: #000;
}
.cv-grade-title {
  font-size: 16px;
  font-weight: 700;
}
.cv-grade-detail {
  display: flex;
  padding-left: 40px;
  font-size: 14px;
}
.detail-label {
  flex: none;
  display: inline-block;
  min-width: 100px;
}
.detail-options span {
  margin-right: 30px;
  position: relative;
  color: #999;
}
.detail-options .option-check::after {
  content: '';
  width: 200%;
  height: 173%;
  position: absolute;
  top: -35%;
  left: -21%;
  background-image: url('../../../assets/images/circle.png');
  background-repeat: no-repeat;
  color: black;
  background-size: contain;
}
.cv-level-box {
  position: absolute;
  top: 45px;
  right: 45px;
  width: 120px;
}
.cv-level-box img {
  width: 100%;
}
.cv-grade-result {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.cv-grade-result .grade {
  font-size: 26px;
  font-weight: 600;
}
.cv-choose-category {
  border: 1px solid #bfbfbf;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 14px;
}
.checkbox-box {
  display: flex;
}
.checkbox-label {
  flex: none;
  word-break: keep-all;
  margin-right: 10px;
  font-weight: 700;
}
.category-alert {
  color: #ff9966;
  margin: 10px 0;
  font-size: 12px;
}
.btn-box {
  display: flex;
  justify-content: center;
  padding: 10px;
}
.grade-num {
  font-size: 26px;
  font-weight: 700;
}
.margin-md {
  margin: 5px;
}
.word-break-class {
  height: unset !important;
  white-space: pre-wrap !important;
}
</style>
